import { createSelector } from 'reselect';
import { AppState } from 'store/types/Store';

export const getField = (state: AppState) => state.field;

export const getFieldUuid = createSelector(
  [getField],
  (field) => field.uuid ?? ''
);
